import { render, staticRenderFns } from "./OpportunityEditContainer.vue?vue&type=template&id=5b823567&"
import script from "./OpportunityEditContainer.vue?vue&type=script&lang=js&"
export * from "./OpportunityEditContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports